import { onOwnwellDotCom } from "./onOwnwellDotCom";

export const isStagingEnv = () => {
	return process.env.NODE_ENV === "production" && !onOwnwellDotCom();
};
